import { createPublicClient, http } from 'viem';
import { worldchain } from 'viem/chains';
import { CONSTANTS } from '@/constants';

export const publicClient = createPublicClient({
  chain: worldchain,
  transport: http(CONSTANTS.RPC),
});
